import { LazyRouterProvider } from './providers/lazy-router-provider';

export function App() {
  return <LazyRouterProvider />;
}

export default App;
